import 'polyfills';
import React, { useEffect, useState, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import {
  Routes as Switch,
  Route,
  useLocation,
  unstable_HistoryRouter as HistoryRouter
} from 'react-router-dom';
import axios from 'axios';
import { isEmpty } from 'lodash-es';

import 'shared/services/tracking';
import history from 'shared/services/history';
import { APP_ROUTE_V2 } from 'paths';
import V2Entry from 'v2-entry';

export const ConfigContext = React.createContext();

const EntryPoint = () => {
  const [config, setConfig] = useState();
  const { pathname } = useLocation();

  useEffect(() => {
    const { href } = window.location;
    const isV2Request = pathname.startsWith(APP_ROUTE_V2);
    if (isV2Request) {
      // first occurrence only in order not to remove possible query params
      const newUrl = href.replace(/\/v2/, '');
      // no back in history stack
      window.location.replace(newUrl);
    } else {
      const getConfig = async () => {
        const response = await axios({
          url: '/config.json',
          method: 'get'
        });
        setConfig(response.data);
      };

      getConfig();
    }
  }, [pathname]);

  if (isEmpty(config)) return null;

  return (
    <ConfigContext.Provider value={config}>
      <Suspense fallback={null}>
        <Switch>
          <Route path="*" element={<V2Entry />} />
        </Switch>
      </Suspense>
    </ConfigContext.Provider>
  );
};
const root = createRoot(document.getElementById('root'));

root.render(
  <HistoryRouter history={history}>
    <EntryPoint />
  </HistoryRouter>
);
